<template>
  <v-app :class="'app--' + appBreakpoint">
    <div
      id="app-container"
      ref="appContainer"
      class="v-sheet v-sheet--tile theme--light"
      :class="textZoom"
      :style="{ height: appSizes.height + 'px', width: appSizes.width + 'px' }"
    >
      <keep-alive include="mdd-inicio">
        <router-view></router-view>
      </keep-alive>
      <v-dialog v-model="showMsg" width="500">
        <v-card>
          <v-card-text class="pt-6">{{ showMsg }}</v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="msgLeido">
              {{ t.app.cerrar }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  mounted() {
    let _this = this;

    // app/resize
    this.$store.commit("app/setIniSizes");
    this.$store.commit("app/resize", {
      bodyRef: this.$el,
      vuetify: this.$vuetify
    });

    window.screen.orientation.addEventListener("change", function() {
      _this.$store.commit("app/resize", {
        bodyRef: _this.$el,
        vuetify: _this.$vuetify
      });
    });

    window.addEventListener("resize", function() {
      _this.$store.commit("app/resize", {
        bodyRef: _this.$el,
        vuetify: _this.$vuetify
      });
    });

    this.$root.$grefs.appContainer = this.$refs.appContainer;
  },
  computed: {
    appBreakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    appSizes() {
      return this.$store.getters["app/sizes"];
    },
    showDialog() {
      return this.$route.meta.showDialog;
    },
    showFull() {
      return this.$vuetify.breakpoint.smAndDown || this.$route.meta.showFull;
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    },
    textZoom() {
      let tam = this.userConfig.mdd.tam;
      return "txt-zoom-" + tam;
    },
    userConfig() {
      return this.$store.getters["user/config"];
    },
    vuetify() {
      return this.$vuetify;
    },
    showMsg: {
      get() {
        return this.$store.getters["app/msg"];
      },
      set() {
        this.$store.commit("app/msg", "");
      }
    }
  },
  methods: {
    msgLeido() {
      this.$store.commit("app/msg", "");
    }
  }
};
</script>

<style>
nav {
  z-index: 5 !important;
}

div#app {
  background-color: burlywood;
  /* alineacion vertical del contenido */
  -webkit-box-align: stretch !important;
  -ms-flex-align: stretch !important;
  align-items: stretch !important;
  /* centrar */
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  /* altura maxima disponible */
  display: grid;
  display: -moz-grid;
  display: -ms-grid;
}

/* #app.app--xs .v-toolbar__title { font-size: 1.5em }
#app.app--sm .v-toolbar__title { font-size: 1.75em }
#app.app--md .v-toolbar__title { font-size: 1.75em }
#app.app--lg .v-toolbar__title { font-size: 1.75em }
#app.app--xl .v-toolbar__title { font-size: 2em } */

body {
  overflow: hidden;
}

#app-container {
  overflow-y: auto;
  overflow-x: hidden;
}

#app-container > div.container {
  height: 100%;
}

::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  background-color: "#CCC";
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25);
  border: 0px none "#CCC";
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.4);
}
::-webkit-scrollbar-track {
  background-color: "#CCC";
  border: none;
}

.txt-zoom-1 .zoom {
  font-size: 16px;
}

.txt-zoom-2 .zoom {
  font-size: 18px;
}
.txt-zoom-3 .zoom {
  font-size: 20px;
}
.txt-zoom-4 .zoom {
  font-size: 22px;
}
.txt-zoom-5 .zoom {
  font-size: 24px;
}

.txt-zoom-1 .zoom .vdm {
  font-size: 20px;
  font-style: italic;
}
.txt-zoom-2 .zoom .vdm {
  font-size: 22px;
  font-style: italic;
}
.txt-zoom-3 .zoom .vdm {
  font-size: 24px;
  font-style: italic;
}
.txt-zoom-4 .zoom .vdm {
  font-size: 26px;
  font-style: italic;
}
.txt-zoom-5 .zoom .vdm {
  font-size: 28px;
  font-style: italic;
}
</style>
